import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Order, TaxContent } from '@/models';
import { CountryCode } from '@/store/ui';
import { Routes } from '@/router';

@Component({
  name: 'CmgTaxAndFees',
})
export default class CmgTaxAndFees extends Vue {
  taxContent: TaxContent | null = null;

  @Prop({ required: true, type: Object })
  order!: Order;

  formatTotal(total: number | null): string {
    return this.$services.utils.formatPrice(total);
  }

  get isDelivery(): boolean {
    return this.$services.order.isDelivery();
  }

  get hasServiceFee(): boolean {
    return this.order.taxesAndFees.deliveryServiceFee > 0;
  }

  get hasRegulatoryFee(): boolean {
    return this.order.taxesAndFees.deliveryRegulatoryFee > 0;
  }

  get hasTaxesAndFees(): boolean {
    return !!this.order.taxesAndFees;
  }

  get taxLine(): string {
    return this.isUK ? 'VAT Included' : 'Tax';
  }

  get isUK(): boolean {
    return this.$appStore.state.ui.countryProfile.countryCode == CountryCode.GB
  }

  async mounted() {
    let taxContent = this.$services.config.getTaxContent();
    if (taxContent) {
      this.taxContent = taxContent;
    } else {
      await this.$services.config.setTaxContent();
      this.taxContent = this.$services.config.getTaxContent()!;
    }
  }
}
